import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { AttributeGroupInfoRules } from '../partials/AttributeGroupInfoRules';

function AttributeGroupInfoDefault({ rules, ruleCombination }: AttributeGroupInfoRules) {
  return <AttributeGroupInfoRules rules={rules} ruleCombination={ruleCombination} />;
}

export const AttributeGroupInfoDefaultView = asView(AttributeGroupInfoDefault);
export type AttributeGroupInfoDefaultView = ComponentProps<typeof AttributeGroupInfoDefaultView>;
